import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { images } from "../../../action/customFn";
import LoginFormNew from "./components/LoginFormNew";
import GoogleAuthComponent from "../GoogleAuth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import CompanyLoginForm from "./components/companyLoginForm";

function Login() {
  const navigate = useNavigate();
  const [googleError, setGoogleError] = useState({ error: false, msg: "" });
  const location = useLocation();
  return (
    <>
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="authroot-illustration-wr"
      >
        <img src={"/login-olly.jpg"} alt="" />
        <p
          onClick={() => {
            if(location.state) navigate(location.state);
            else navigate(-1);
          }}
          className="back"
        >
          <FaArrowLeft />
          Back
        </p>
      </motion.section>
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="authroot-form-wr"
      >
        <p
          onClick={() => {
            if(location.state) navigate(location.state || "/");
            else navigate(-1);
          }}
          className="back back2"
        >
          <FaArrowLeft />
          Back
        </p>
        <figure>
          <img src={images["metb-full-logo-black.svg"]} alt="" />
        </figure>
        {
          location.pathname === "/login/company" ? <h1>Metbrains Global</h1> :
            <h1>Sign In to Limitless Learning!</h1>
        }
        <p style={{ fontSize: "14px", color: "#565656" }}>
          Sign in to your {location.pathname === "/login/company" ? "" :"LMS"} account and start
        </p>
        <p style={{ fontSize: "14px", color: "#565656" }}>
          your journey to a better future.
        </p>
        {
          location.pathname === "/login/company" ? <CompanyLoginForm googleError={googleError} /> : 
          <LoginFormNew googleError={googleError} />
        }
        <div className="forgot-password">
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <input
              type="checkbox"
              name=""
              id="remember-me-login"
              style={{ cursor: "pointer" }}
            />
            <label htmlFor="remember-me-login" style={{ cursor: "pointer" }}>
              Remember Me
            </label>
          </div>
          <Link to={"/login/forgot-password"}>
            <p>Forgot Password?</p>
          </Link>
        </div>
        {/* <div className="or-divider">
          <span>OR</span>
        </div>
        <div className="options-tray">
          <GoogleAuthComponent
            navigate={navigate}
            setGoogleError={setGoogleError}
          />
        </div> */}
        <div
          className="login-footer"
          style={{ position: "absolute", bottom: "20px" }}
        >
          <p style={{ fontSize: "13px" }}>
            By signing in you acknowledge that you have read and agree to our{" "}
            <Link style={{ color: "rgb(41, 49, 59)", fontWeight: "500", textDecoration:"underline" }}>
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link style={{ color: "rgb(31, 37, 45)", fontWeight: "500", textDecoration:"underline" }}>
              Privacy Policy
            </Link>
          </p>
        </div>
      </motion.section>
    </>
  );
}

export default Login;
